window.getHeaderHeight = () => {
  const announcement = document.querySelector("#shopify-section-announcement-bar .announcement-bar")
  const header = document.querySelector("#shopify-section-header")

  const announcementVisible = announcement && announcement.offsetParent !== null
  const headerVisible = header && header.offsetParent !== null

  const announcementHeight = announcementVisible ? announcement.offsetHeight : 0
  const headerHeight = headerVisible ? header.offsetHeight : 0

  const totalHeight = announcementHeight + headerHeight

  return totalHeight
}

window.getStickyTop = () => getComputedStyle(document.documentElement)
  .getPropertyValue("--sticky-top")
  .replace("calc(", "")
  .replace(")", "")
  .split("+")
  .map(v => parseFloat(v.trim()))
  .reduce((a, b) => a + b, 0)

addEventListener("DOMContentLoaded", () => {
  
  
  document.querySelectorAll(".marquee").forEach(marquee => {
    if ("infinite" in marquee.dataset) {
      const original = Array.from(marquee.children)
      for (let i = 0; i < 39; i++) {
        original.forEach(child => marquee.appendChild(child.cloneNode(true)))
      }
      if (marquee.dataset.speed) {
        marquee.dataset.speed = parseFloat(marquee.dataset.speed) * 40
      } else {
        marquee.dataset.speed = 15 * 40
      }
    }
    const div = document.createElement("div")
    div.className = "marquee-sub"
    div.append(...marquee.children)
    marquee.append(div)
    marquee.append(div.cloneNode(true))
    const measure = div.cloneNode(true)
    measure.classList.add("marquee-measure")
    marquee.append(measure)
    if (marquee.dataset.speed) {
      marquee.dataset.marquee = Math.random()
      const style = document.createElement("style")
      style.textContent = `
        [data-marquee="${marquee.dataset.marquee}"].marquee.scrolling .marquee-sub {
          animation: marquee ${parseFloat(marquee.dataset.speed)}s linear infinite;
        }
      `
      document.body.appendChild(style)
    }
    if ("pauseHover" in marquee.dataset) {
      marquee.addEventListener("mouseenter", () => marquee.querySelectorAll(".marquee-sub").forEach(e => e.style.animationPlayState = "paused"))
      marquee.addEventListener("mouseleave", () => marquee.querySelectorAll(".marquee-sub").forEach(e => e.style.animationPlayState = "running"))
    }
    marquee.classList.add("initialised")
    const adjust = () => marquee.classList.toggle("scrolling", measure.clientWidth > marquee.clientWidth)
    adjust()
    window.addEventListener("resize", adjust)
  })

  

  const announcement = document.querySelector("#shopify-section-announcement-bar .announcement-bar")
  const header = document.querySelector("#shopify-section-header")
  
  function updateHeaderHeight() {
    document.documentElement.style.setProperty("--header-height", `${getHeaderHeight()}px`)
  }
  
  updateHeaderHeight()
  
  const observer = new MutationObserver(updateHeaderHeight)
  const config = { attributes: true, childList: true, subtree: true }
  
  observer.observe(announcement, config)
  observer.observe(header, config)
  
  window.addEventListener("resize", updateHeaderHeight)

  // Modals

  const modals = document.createElement("div")
  modals.id = "modals"
  document.body.append(modals)
  
  function makeModal(title, content, id) {
    const container = document.createElement("div")
    if (id) {
      container.id = id
    }
    container.classList.add("modal-container")
    container.innerHTML = `
      <div class="modal-element">
        <div class="modal-title-row">
          <div class="modal-title">${title ?? "Modal"}</div>
          <svg width="28" height="28" viewBox="0 0 24 24"><path d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" /></svg>
        </div>
        <div class="modal-contents"></div>
      </div>
    `
    const contents = container.querySelector(".modal-contents")
    if (typeof content === "string") {
      contents.innerHTML = content
    } else {
      contents.append(...content)
    }
    return container
  }
  
  function handleModal(modal, close, func) {
    modal.querySelector("svg").addEventListener("click", close)
    let down
    modal.addEventListener("mousedown", e => down = e.target)
    modal.addEventListener("mouseup", e => {
      if (down === e.target && e.target.classList.contains("modal-container")) {
        close()
      }
    })
    modals.append(modal)
    if (func) {
      const modalElement = modal.querySelector(".modal-element")
      modalElement.close = close
      func(modalElement)
    }
  }
  
  document.querySelectorAll(".modal").forEach(e => {
    const modal = makeModal(e.dataset.title, e.children, e.dataset.modalId ?? e.dataset.trigger + "-modal")
    handleModal(modal, () => modal.classList.remove("open"))
    e._modal = modal
  })
  
  document.addEventListener("click", e => {
    document.querySelectorAll(".modal").forEach(el => {
      if (e.target.closest(`.${el.dataset.trigger}`)) {
        modals.append(el._modal)
        setTimeout(() => el._modal.classList.add("open"), 0)
      }
    })
  })
  
  document.querySelectorAll("[data-modal]").forEach(el => {
    const modal = makeModal(
      el.dataset.modalTitle,
      el.dataset.modal,
      el.dataset.modalId
    )
  
    handleModal(modal, () => {
      modal.classList.remove("open")
      const code = el.getAttribute("data-modal-close")
      if (code) Function(code).call(el._modal)
    })
  
    el._modal = modal
  
    el.addEventListener("click", () => {
      modals.append(modal)
      setTimeout(() => {
        modal.classList.add("open")
        const code = el.getAttribute("data-modal-open")
        if (code) Function(code).call(el._modal)
      }, 0)
    })
  })
  
  function showModal(title, content, func, id) {
    const modal = makeModal(title, content, id)
    handleModal(modal, () => {
      modal.classList.remove("open")
      setTimeout(() => modal.remove(), 150)
    }, func)
    setTimeout(() => modal.classList.add("open"), 0)
  }

  window.showModal = showModal

  // Tooltips

  const tooltips = document.createElement("div")
  tooltips.id = "tooltips"
  document.body.append(tooltips)
  
  let lastElement
  
  function tooltipVisibility(tooltip, visible) {
    if (tooltip._animation_duration === undefined) {
      const styles = getComputedStyle(tooltip)
      const raw = styles.getPropertyValue("--tooltip-animation-length").trim()
      tooltip._animation_duration = raw.endsWith("ms") ? parseFloat(raw) : parseFloat(raw) * 1000
    }
  
    if (tooltip.classList.contains("visible") === visible) {
      tooltip._next = undefined
      return
    }
  
    if (tooltip._timeout === undefined) {
      tooltip._next = undefined
      tooltip.classList.toggle("visible", visible)
      tooltip._timeout = setTimeout(() => {
        tooltip._timeout = undefined
        if (tooltip._next !== undefined) {
          tooltipVisibility(tooltip, tooltip._next)
        }
      }, tooltip._animation_duration)
    } else {
      tooltip._next = visible
    }
  }
  
  function addTooltips() {
    if (lastElement) {
      let node = lastElement
      while (node && node !== document.body) {
        if (node.hasAttribute("data-tooltip")) {
          let tooltip = node._tooltip
          let tooltipText = node._tooltipText
          if (!tooltip) {
            tooltip = document.createElement("div")
            tooltip.className = "tooltip"
            node._tooltip = tooltip
            
            if (node.dataset.tooltipId) {
              tooltip.id = node.dataset.tooltipId 
            }
            
            tooltipText = document.createElement("div")
            tooltipText.className = "tooltip-text"
            tooltipText.innerHTML = node.dataset.tooltip
            tooltip.append(tooltipText)
            node._tooltipText = tooltipText
            
            tooltips.append(tooltip)
          }
          
          const rect = node.getBoundingClientRect()
  
          const x = Math.round(rect.left + rect.width / 2)
          const y = Math.round(rect.top)
  
          const tooltipRect = tooltip.getBoundingClientRect()
          const styles = getComputedStyle(tooltip)
          const verticalDistance = parseFloat(styles.getPropertyValue("--tooltip-vertical-distance"))
          const arrowWidth = parseFloat(styles.getPropertyValue("--tooltip-arrow-size"))
          const edgeBuffer = parseFloat(styles.getPropertyValue("--tooltip-edge-buffer"))
          const padding = parseFloat(styles.getPropertyValue("--tooltip-screen-padding"))
  
          tooltipVisibility(tooltip, true)
  
          const tooltipWidth = tooltipRect.width
          const tooltipHeight = tooltipRect.height
  
          const totalOffset = tooltipHeight + verticalDistance
          
          tooltip.style.setProperty("left", `${x}px`)
          tooltip.style.removeProperty("translate")
          tooltipText.style.removeProperty("translate")
  
          if (y - totalOffset > padding) {
            tooltip.classList.remove("below")
            tooltip.classList.remove("inside")
            tooltip.style.setProperty("top", `${y}px`)
          } else if (y + rect.height + tooltipHeight + verticalDistance < document.documentElement.clientHeight - padding) {
            tooltip.classList.add("below")
            tooltip.classList.remove("inside")
            tooltip.style.setProperty("top", `${y + rect.height}px`)
          } else {
            tooltip.classList.remove("below")
            tooltip.classList.add("inside")
          }
  
          const maxTextShift = (tooltipWidth / 2) - (arrowWidth / 2) - edgeBuffer
  
          const tooltipLeft = x - tooltipWidth / 2
          const tooltipRight = x + tooltipWidth / 2
  
          if (tooltipLeft < padding) {
            const overflow = padding - tooltipLeft
            const textShift = Math.min(overflow, maxTextShift)
            tooltipText.style.setProperty("translate", `${textShift}px`)
  
            if (tooltipLeft + textShift < padding) {
              tooltip.style.setProperty("translate", `${padding - (tooltipLeft + textShift)}px 0`)
            }
          } else if (tooltipRight > document.documentElement.clientWidth - padding) {
            const overflow = tooltipRight - (document.documentElement.clientWidth - padding)
            const textShift = Math.min(overflow, maxTextShift)
            tooltipText.style.setProperty("translate", `-${textShift}px`)
  
            if (tooltipRight - textShift > document.documentElement.clientWidth - padding) {
              tooltip.style.setProperty("translate", `-${(tooltipRight - textShift) - (document.documentElement.clientWidth - padding)}px 0`)
            }
          }
        }
        node = node.parentElement
      }
    }
  }
  
  function removeTooltips(nodes, single) {
    for (let node of nodes) {
      while (node && node !== document.body) {
        if (node._tooltip && (!node.matches(":hover") || single)) {
          tooltipVisibility(node._tooltip, false)
        }
        if (single) break
        node = node.parentElement
      }
    }
  }
  
  let timeout, running
  function reloadTooltips() {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      addTooltips()
      running = false
    }, 250)
    if (running) return
    running = true
    removeTooltips(document.querySelectorAll("[data-tooltip]"), true)
  }
  
  document.addEventListener("mouseover", e => {
    lastElement = e.target
    addTooltips()
  })
  
  document.addEventListener("mouseout", e => removeTooltips([e.target]))
  window.addEventListener("resize", reloadTooltips)
  window.addEventListener("scroll", reloadTooltips)

  // Loader Button

  class LoaderButton extends HTMLElement {
    static get observedAttributes() {
      return ["loading"]
    }
  
    get loading() {
      return this.hasAttribute("loading")
    }
  
    set loading(value) {
      this.toggleAttribute("loading", !!value)
    }
  
    connectedCallback() {
      this.classList.add("ante-button")
      this.addEventListener("click", e => {
        if (this.loading) e.stopImmediatePropagation()
      }, true)
    }
  
    attributeChangedCallback() {
      this.classList.toggle("loading", this.loading)
    }
  }
  
  customElements.define("loader-button", LoaderButton)
})